import React from 'react'
import FarmConnectLogo from 'assets/svg/logo-farm-connect-green-and-white-icon-only.svg?react'
import { useTranslation } from 'react-i18next'
import { useUserSettings } from 'hooks/useUserSettings'

const LoadingScreen: React.FC = () => {
  const { t } = useTranslation()
  const { theme } = useUserSettings()

  return (
    <div className={`loading-container ${theme}-theme`}>
      <div className='logo-container'>
        <div className='logo-spinner'>
          <FarmConnectLogo />
        </div>
        <h1>{t('main.pageIsLoading')}</h1>
      </div>
    </div>
  )
}

export default LoadingScreen
